import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const [expandedMenus, setExpandedMenus] = useState({});
  const location = useLocation();

  const toggleSubmenu = (menuKey) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }));
  };

  const isActive = (path) => location.pathname === path;

  // Sayfa yüklendiğinde ilgili menüyü otomatik aç
  useEffect(() => {
    const path = location.pathname;
    
    // İdari İşler menüsü için
    if (path.startsWith('/idari-isler')) {
      setExpandedMenus(prev => ({ ...prev, idariIsler: true }));
    }
    // İnsan Kaynakları menüsü için
    else if (path.startsWith('/insan-kaynaklari') || path.startsWith('/basvurular') || path.startsWith('/yeni-calisan') || path.startsWith('/tum-calisanlar')) {
      setExpandedMenus(prev => ({ ...prev, insanKaynaklari: true }));
    }
    // Kurumsal menüsü için
    else if (path.startsWith('/duyurular') || path.startsWith('/personel-rehberi') || path.startsWith('/dokuman-merkezi') || path.startsWith('/etkinlik-takvimi') || path.startsWith('/anketler')) {
      setExpandedMenus(prev => ({ ...prev, kurumsal: true }));
    }
    // Projeler menüsü için
    else if (path.startsWith('/inovasyon-oneri')) {
      setExpandedMenus(prev => ({ ...prev, projeler: true }));
    }
    // Sosyal menüsü için
    else if (path.startsWith('/akademi')) {
      setExpandedMenus(prev => ({ ...prev, sosyal: true }));
    }
    // Zimmet Yönetimi menüsü için
    else if (path.startsWith('/zimmet-yonetimi') || path.startsWith('/zimmet-listesi') || path.startsWith('/yeni-zimmet') || path.startsWith('/zimmet-raporlari')) {
      setExpandedMenus(prev => ({ ...prev, zimmetYonetimi: true }));
    }
  }, [location.pathname]);

  return (
    <div className="sidebar modern-sidebar">
      <div className="sidebar-logo modern-sidebar-logo">
        <Link to="/anasayfa" className="text-decoration-none">
          <img 
            src="https://www.kolin.com.tr/Templates/Default/assets/img/logo@2x.png" 
            alt="Kolin İnşaat" 
            className="kolin-logo modern-sidebar-logo-img"
          />
        </Link>
        <div className="sidebar-close modern-sidebar-close" id="sidebar-close">
          <i className='bx bx-left-arrow-alt'></i>
        </div>
      </div>

      <div className="simlebar-sc" data-simplebar>
        <ul className="sidebar-menu tf">
          {/* Anasayfa */}
          <li className="modern-sidebar-item">
            <Link 
              to="/anasayfa" 
              className={`modern-sidebar-link ${isActive('/anasayfa') || isActive('/') ? 'active' : ''}`}
            >
              <i className='bx bxs-home modern-sidebar-icon'></i>
              <span>Anasayfa</span>
            </Link>
          </li>

          {/* Kurumsal */}
          <li className="sidebar-submenu modern-sidebar-item">
            <button 
              className={`modern-sidebar-dropdown ${expandedMenus.kurumsal ? 'active' : ''}`}
              onClick={() => toggleSubmenu('kurumsal')}
            >
              <div className="modern-sidebar-dropdown-content">
                <i className='bx bxs-buildings modern-sidebar-icon'></i>
                <span>Kurumsal</span>
              </div>
              <div className="modern-sidebar-dropdown-icon">
                <i className={`bx bx-chevron-down ${expandedMenus.kurumsal ? 'active' : ''}`}></i>
              </div>
            </button>
            <ul 
              className={`modern-sidebar-dropdown-menu ${expandedMenus.kurumsal ? 'active' : ''}`}
            >
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/duyurular"
                  className={`modern-sidebar-dropdown-link ${isActive('/duyurular') ? 'active' : ''}`}
                >
                  Duyurular
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/personel-rehberi"
                  className={`modern-sidebar-dropdown-link ${isActive('/personel-rehberi') ? 'active' : ''}`}
                >
                  Personel Rehberi
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/dokuman-merkezi"
                  className={`modern-sidebar-dropdown-link ${isActive('/dokuman-merkezi') ? 'active' : ''}`}
                >
                  Doküman Merkezi
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/etkinlik-takvimi"
                  className="modern-sidebar-dropdown-link disabled"
                >
                  Etkinlik Takvimi
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/anketler"
                  className={`modern-sidebar-dropdown-link ${isActive('/anketler') ? 'active' : ''}`}
                >
                  Anketler
                </Link>
              </li>
            </ul>
          </li>

          {/* İnsan Kaynakları */}
          <li className="sidebar-submenu modern-sidebar-item">
            <button 
              className={`modern-sidebar-dropdown ${expandedMenus.insanKaynaklari ? 'active' : ''}`}
              onClick={() => toggleSubmenu('insanKaynaklari')}
            >
              <div className="modern-sidebar-dropdown-content">
                <i className='bx bxs-user modern-sidebar-icon'></i>
                <span>İnsan Kaynakları</span>
              </div>
              <div className="modern-sidebar-dropdown-icon">
                <i className={`bx bx-chevron-down ${expandedMenus.insanKaynaklari ? 'active' : ''}`}></i>
              </div>
            </button>
            <ul 
              className={`modern-sidebar-dropdown-menu ${expandedMenus.insanKaynaklari ? 'active' : ''}`}
            >
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/insan-kaynaklari"
                  className={`modern-sidebar-dropdown-link ${isActive('/insan-kaynaklari') ? 'active' : ''}`}
                >
                  İK Dashboard
                </Link>
              </li>
            <li className="modern-sidebar-dropdown-item">
              <Link 
                to="/basvurular"
                className={`modern-sidebar-dropdown-link ${isActive('/basvurular') ? 'active' : ''}`}
              >
                Başvurular
              </Link>
            </li>
            <li className="modern-sidebar-dropdown-item">
              <Link 
                to="/yeni-calisan"
                className={`modern-sidebar-dropdown-link ${isActive('/yeni-calisan') ? 'active' : ''}`}
              >
                Yeni Çalışan Kaydı
              </Link>
            </li>
            <li className="modern-sidebar-dropdown-item">
              <Link 
                to="/tum-calisanlar"
                className={`modern-sidebar-dropdown-link ${isActive('/tum-calisanlar') ? 'active' : ''}`}
              >
                Tüm Çalışanlar
              </Link>
            </li>
            </ul>
          </li>

          {/* İdari İşler */}
          <li className="sidebar-submenu modern-sidebar-item">
            <button 
              className={`modern-sidebar-dropdown ${expandedMenus.idariIsler ? 'active' : ''}`}
              onClick={() => toggleSubmenu('idariIsler')}
            >
              <div className="modern-sidebar-dropdown-content">
                <i className='bx bxs-briefcase modern-sidebar-icon'></i>
                <span>İdari İşler</span>
              </div>
              <div className="modern-sidebar-dropdown-icon">
                <i className={`bx bx-chevron-down ${expandedMenus.idariIsler ? 'active' : ''}`}></i>
              </div>
            </button>
            <ul 
              className={`modern-sidebar-dropdown-menu ${expandedMenus.idariIsler ? 'active' : ''}`}
            >
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/idari-isler"
                  className={`modern-sidebar-dropdown-link ${isActive('/idari-isler') ? 'active' : ''}`}
                >
                  Talep Oluştur
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/idari-isler-talepler"
                  className={`modern-sidebar-dropdown-link ${isActive('/idari-isler-talepler') ? 'active' : ''}`}
                >
                  Talepler
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/idari-isler-istatistikler"
                  className={`modern-sidebar-dropdown-link ${isActive('/idari-isler-istatistikler') ? 'active' : ''}`}
                >
                  İstatistikler
                </Link>
              </li>
            </ul>
          </li>

          {/* Zimmet Yönetimi */}
          <li className="sidebar-submenu modern-sidebar-item">
            <button 
              className={`modern-sidebar-dropdown ${expandedMenus.zimmetYonetimi ? 'active' : ''}`}
              onClick={() => toggleSubmenu('zimmetYonetimi')}
            >
              <div className="modern-sidebar-dropdown-content">
                <i className='bx bxs-package modern-sidebar-icon'></i>
                <span>Zimmet Yönetimi</span>
              </div>
              <div className="modern-sidebar-dropdown-icon">
                <i className={`bx bx-chevron-down ${expandedMenus.zimmetYonetimi ? 'active' : ''}`}></i>
              </div>
            </button>
            <ul 
              className={`modern-sidebar-dropdown-menu ${expandedMenus.zimmetYonetimi ? 'active' : ''}`}
            >
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/zimmet-yonetimi"
                  className={`modern-sidebar-dropdown-link ${isActive('/zimmet-yonetimi') ? 'active' : ''}`}
                >
                  Ana Sayfa
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/zimmet-listesi"
                  className={`modern-sidebar-dropdown-link ${isActive('/zimmet-listesi') ? 'active' : ''}`}
                >
                  Zimmet Listesi
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/yeni-zimmet"
                  className={`modern-sidebar-dropdown-link ${isActive('/yeni-zimmet') ? 'active' : ''}`}
                >
                  Yeni Zimmet
                </Link>
              </li>
              <li className="modern-sidebar-dropdown-item">
                <Link 
                  to="/zimmet-raporlari"
                  className={`modern-sidebar-dropdown-link ${isActive('/zimmet-raporlari') ? 'active' : ''}`}
                >
                  Raporlar
                </Link>
              </li>
            </ul>
          </li>

          {/* Projeler */}
          <li className="sidebar-submenu modern-sidebar-item">
            <button 
              className={`modern-sidebar-dropdown ${expandedMenus.projeler ? 'active' : ''}`}
              onClick={() => toggleSubmenu('projeler')}
            >
              <div className="modern-sidebar-dropdown-content">
                <i className='bx bxs-bolt modern-sidebar-icon'></i>
                <span>Projeler</span>
              </div>
              <div className="modern-sidebar-dropdown-icon">
                <i className={`bx bx-chevron-down ${expandedMenus.projeler ? 'active' : ''}`}></i>
              </div>
            </button>
            <ul 
              className={`modern-sidebar-dropdown-menu ${expandedMenus.projeler ? 'active' : ''}`}
            >
              <li className="modern-sidebar-dropdown-item">
                <Link to="/inovasyon-oneri" className="modern-sidebar-dropdown-link">
                  Öneri ve Talep Kutusu
                </Link>
              </li>
            </ul>
          </li>

          {/* Sosyal */}
          <li className="sidebar-submenu modern-sidebar-item">
            <button 
              className={`modern-sidebar-dropdown ${expandedMenus.sosyal ? 'active' : ''}`}
              onClick={() => toggleSubmenu('sosyal')}
            >
              <div className="modern-sidebar-dropdown-content">
                <i className='bx bxs-group modern-sidebar-icon'></i>
                <span>Sosyal</span>
              </div>
              <div className="modern-sidebar-dropdown-icon">
                <i className={`bx bx-chevron-down ${expandedMenus.sosyal ? 'active' : ''}`}></i>
              </div>
            </button>
            <ul 
              className={`modern-sidebar-dropdown-menu ${expandedMenus.sosyal ? 'active' : ''}`}
            >
              <li className="modern-sidebar-dropdown-item">
                <a 
                  href="https://akademi.koloğlu.com.tr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="modern-sidebar-dropdown-link"
                >
                  Koloğlu Akademi
                </a>
              </li>
            </ul>
          </li>


        </ul>
      </div>
    </div>
  );
};



export default Sidebar; 